export const memberSex = ['Male', 'Female'] as const;
